import Vue from 'vue'
import Router from 'vue-router'

import PublicLayout from '@/pages/public/PublicLayout'
import Home from '@/pages/public/Home'
import ContactUs from '@/pages/public/Contact.vue'
import ContactUsDev from '@/pages/public/ContactDeveloper.vue'
import Product from '@/pages/public/Product'
import Install from '@/pages/public/Install'
import About from '@/pages/public/About'
import Tech from '@/pages/public/Tech'
import AppsUser from '@/pages/public/AppsUser'
import AppsDev from '@/pages/public/AppsDev'

import DeveloperLayout from '@/pages/developer/DeveloperLayout'
import DashboardDeveloper from '@/pages/developer/DashboardDeveloper'
import EditProductDeveloper from '@/pages/developer/EditProductDeveloper'
import ListProductDeveloper from '@/pages/developer/ListProductDeveloper'
import WithdrawDeveloper from '@/pages/developer/WithdrawDeveloper'
import DashboardReview from '@/pages/developer/DashboardReview'

import AdminLayout from '@/admin/containers/Full'
import DashboardAdmin from '@/admin/views/Dashboard'
import ListProductAdmin from '@/admin/views/product/ListApp'
import EditProductAdmin from '@/admin/views/product/EditApp'
import ListUser from '@/admin/views/user/ListUser'
import EditUser from '@/admin/views/user/EditUser'
import ListSubscribers from '@/admin/views/subscriber/ListSubscribers'
import Logout from '@/admin/components/Logout'
import DashboardReviewAdmin from '../admin/views/DashboardReviewAdmin.vue'
import ListCustomer from '@/admin/views/customer/ListCustomer'
import EditCustomer from '@/admin/views/customer/EditCustomer'

import ProfileLayout from '@/pages/profile/ProfileLayout'
import ViewProfile from '@/pages/profile/ViewProfile'
import EditProfile from '@/pages/profile/EditProfile'
import EditPasswordProfile from '@/pages/profile/EditPasswordProfile'
import ProductsProfile from '@/pages/profile/ProductsProfile'
import Purchases from '@/pages/profile/Purchases'
import EditReviewProfile from '@/pages/profile/EditReviewProfile'

import AuthLayout from '@/pages/auth/AuthLayout'
import Login from '@/pages/auth/Login'
import SignUp from '@/pages/auth/SignUp'
import ConfirmEmail from '@/pages/auth/ConfirmEmail'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import ResetPassword from '@/pages/auth/ResetPassword'

import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // App store / Developer Dasboard
    {
      path: '/beta',
      component: PublicLayout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/beta/about-us',
          name: 'About Us',
          component: About
        },
        {
          path: '/beta/tech',
          name: 'tech',
          component: Tech
        },
        {
          path: '/beta/apps-user',
          name: 'Apps User',
          component: AppsUser
        },
        {
          path: '/beta/apps-developer',
          name: 'Apps Developer',
          component: AppsDev
        },
        {
          path: '/beta/contact-us',
          name: 'Contact Us',
          component: ContactUs
        },
        {
          path: '/beta/contact-us-developer',
          name: 'Contact Us Developer',
          component: ContactUsDev
        },
        {
          path: '/beta/product/:slug',
          name: 'Product',
          component: Product
        },
        {
          path: '/beta/purchase/:id/install',
          name: 'Install',
          component: Install,
          meta: { requiresAuth: true }
        },
        {
          path: '/beta/developer',
          component: DeveloperLayout,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'dashboard',
              name: 'DashboardDeveloper',
              component: DashboardDeveloper
            },
          
            {
              path: 'product/:slug/review',
              name: 'DashboardReview',
              component: DashboardReview
            },
            {
              path: 'product/:slug/edit',
              name: 'EditProductDeveloper',
              component: EditProductDeveloper
            },
            {
              path: 'product/create',
              name: 'CreateProductDeveloper',
              component: EditProductDeveloper
            },
            {
              path: 'product/',
              name: 'ListProductDeveloper',
              component: ListProductDeveloper
            },
            {
              path: 'withdraw',
              name: 'WithdrawDeveloper',
              component: WithdrawDeveloper
            }
          ]
        },
        {
          path: '/beta/profile',
          component: ProfileLayout,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/',
              name: 'Profile',
              component: ViewProfile
            },
            {
              path: 'apps',
              name: 'MyApp',
              component: ProductsProfile
            },
            {
              path: 'purchase',
              name: 'MyPurchases',
              component: Purchases
            },
            {
              path: 'purchase/:id/review',
              name: 'EditReviewProfile',
              component: EditReviewProfile
            },
            {
              path: 'edit',
              name: 'EditProfile',
              component: EditProfile
            },
            {
              path: 'password',
              name: 'EditPasswordProfile',
              component: EditPasswordProfile
            }
          ]
        }
      ]
    },
    {
      path: '/beta/auth',
      component: AuthLayout,
      children: [
        {
          path: '/',
          name: 'Login',
          component: Login
        },
        {
          path: '/beta/sign-up',
          name: 'Signup',
          component: SignUp
        },
        {
          path: '/beta/confirm-email',
          name: 'ConfirmEmail',
          component: ConfirmEmail
        },
        {
          path: '/beta/forgot-password',
          name: 'ForgotPassword',
          component: ForgotPassword
        },
        {
          path: '/beta/reset-password',
          name: 'ResetPassword',
          component: ResetPassword
        }
      ]
    },
    // Admin Dashboard
    {
      path: '/beta/admin',
      redirect: '/beta/admin/dashboard',
      component: AdminLayout,
      name: 'Admin Home',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: DashboardAdmin
        },
        {
          path: 'product/:slug/review',
          name: 'DashboardReviewAdmin',
          component: DashboardReviewAdmin
        },
        {
          path: 'product/',
          name: 'App Management',
          component: ListProductAdmin
        },
        {
          path: 'product/:slug/manage',
          name: 'Edit App',
          component: EditProductAdmin
        },
        {
          path: 'user/',
          name: 'List of users',
          component: ListUser
        },
        {
          path: 'user/:_id/edit',
          name: 'Edit user',
          component: EditUser
        },
        {
          path: 'customer/',
          name: 'List of Customers',
          component: ListCustomer
        },
        {
          path: 'customer/:_id/edit',
          name: 'Edit customer',
          component: EditCustomer
        },
        {
          path: 'subscribers',
          name: 'List of Subscribers',
          component: ListSubscribers
        },
        {
          path: 'logout',
          component: Logout
        }
      ]
    },
    {
      path: '*',
      redirect: '/beta/'
    }
  ]
})
// Check authentication
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: '/beta/auth/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
// Check admin Role
router.beforeEach((to, from, next) => {
  if (to.path === '/beta/' && store.getters.hasRole(['admin'])) {
    next({
      path: '/beta/admin'
    })
  } else {
    next()
  }
})
// Check roles
router.beforeEach((to, from, next) => {
  const routeMatched = to.matched.find(record => record.meta.requiresRole)
  if (routeMatched && !store.getters.hasRole(routeMatched.meta.requiresRole)) {
    store.dispatch('flash', {
      message: 'Sorry, you are not autorized to access to this page',
      type: 'warning'
    })
    next({
      name: 'Home'
    })
  } else {
    next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js